import { ERRORS } from 'shared/constants/validation-constants';
import { handleSnackbarNotify } from './handleSnackbarNotify';

export const handleCatchNotValidationError = (err: any, dispatch: any) => {
  if (err.error.status < 400 || err.error.status > 499) {
    handleSnackbarNotify(dispatch, ERRORS.commonError, 'error');
  }
};
